export const MAX_SIZE_ALLOWED = 1000000;
export const MAX_SIZE_ALLOWED_MB = 1;
export const MAIL_KONECTA_EXTERNAL = "atraccioneinclusion@konecta-group.com";
export const MAIL_KONECTA_INTERNAL = "expansiondetalentos@konecta-group.com";
